import { issuesReferencePickerPlugin } from "./issuesReferencePickerPlugin";
export default issuesReferencePickerPlugin;
